import Vue from "vue";
import Router from "vue-router";
import authLayout from "@/router/layouts/authLayout";
import mainLayout from "@/router/layouts/mainLayout";
import errorLayout from "@/router/layouts/errorLayout";
import referralLayout from "@/router/layouts/referralLayout";
import guard from "@/router/guard";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH,
  routes: [
    ...authLayout,
    ...mainLayout,
    ...errorLayout,
    ...referralLayout,
    {
      path: "*",
      redirect: "/404",
    },
  ],
});

router.beforeEach(guard);

export default router;
